const ANONYMOUS_FEATURE_FLAG_KEY = 'anon';

export function getFeatureFlagKey(userId?: string) {
  return userId || ANONYMOUS_FEATURE_FLAG_KEY;
}

export const FEATURE_FLAGS_CONFIG = {
  core: {
    authorizationKey: process.env.NEXT_PUBLIC_SPLITIO_APIKEY!,
    key: ANONYMOUS_FEATURE_FLAG_KEY,
  },
};
